import React from 'react';
import './Title.module.scss';

type Props = {
  attributes: any;
};

export default function Title({ attributes }: Props) {
  return (
    <div styleName="title">
      <h2>{attributes?.title}</h2>
    </div>
  );
}
